import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  font-size: 1.2em;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const StyledLogo = styled.img`
  margin-right: 10px;
`;

const BrandHeader = () => {
  return (
    <StyledDiv>
      <StyledLogo src='/logo/logo_s.png'/>
      Celestial Octopus
    </StyledDiv>
  );
};

export {
  BrandHeader,
};